import { Box, ModalBackdropStyled, SideSheetBody, SideSheetContentCol, Text } from '@bechtel/gds';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const MoreOptionItem = styled(Box).attrs({
  pl: { sm: '450' },
})`
  height: ${({ theme }) => theme.componentStyles.pageHeaderHeight};
  align-items: center;
`;
export const SideSheetBodyStyled = styled(SideSheetBody)`
  ${({ theme }) => css`
    padding-top: ${theme.spacings[400]};
    padding-left: ${theme.spacings[500]};
  `};
`;

export const SideSheetContentColStyled = styled(SideSheetContentCol)`
  ${({ theme }) => css`
    margin-right: ${theme.spacings[100]};
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: ${theme.spacings[200]};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.grey[300]};
      border-radius: ${theme.radii[100]};
    }
  `};
`;
export const ItemTextStyled = styled(Text).attrs({
  size: 300,
  family: 'openSansCondensed',
})`
  ${({ theme }) => css`
    color: ${theme.colors.primary[900]};
    align-self: center;
    margin-left: ${theme.spacings[450]};
  `};
`;

export const NavLinkStyled = styled(NavLink)`
  ${({ theme }) => css`
    text-decoration: none;
    &:hover {
      background-color: ${theme.colors.primary[100]};
    }
  `};
`;

export const DrawerBackdropStyled = styled(ModalBackdropStyled)`
  z-index: 2;
  position: absolute;
  left: 80px;
  top: 40px;
  height: calc(100% - ${({ theme }) => theme.componentStyles.pageHeaderHeight});
  z-index: 2;
`;

export const DrawerOuterStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 225px;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  box-shadow: ${({ theme }) => theme.componentStyles.boxShadow};
`;
